import EmblaCarousel from 'embla-carousel';
import {clickEvent, documentLoadEvent} from "../../../../webpack/modules/events";
import {showReviewImageZoomPopup} from "../../../../webpack/modules-optimized/popup-review-image-zoom";
import {showModal} from "../../../../webpack/modules-optimized/modal";
import {onVisible} from "../../../../scripts/Tools/visible-element-observer";

let reviewV2ImageEmbla = null;

documentLoadEvent(function() {
    const block = document.querySelector('#product-list-page #product-list-reviews-v2');
    if (!block) {
        return;
    }

    onVisible(block.querySelectorAll('.review-v2-images-carousel'), function(slider) {
        initReviewImagesCarousel(slider);
    }, 0.7);
});

clickEvent('#product-list-page #product-list-reviews-v2 .review-image-zoom-popup', true, function (element) {
    showReviewImageZoomPopup(Number(element.dataset.position));
});

clickEvent('#product-list-page #product-list-reviews-v2 .review-v2-image-link', true, function (element, event) {
    event.preventDefault();

    let images = [];
    try {
        images = JSON.parse(element.dataset.images || '[]');
    } catch (error) {
        return;
    }

    if (!images.length) {
        return;
    }

    openReviewV2ImageModal(images, Number(element.dataset.imageIndex || 0));
});

function openReviewV2ImageModal(images, startIndex) {
    const modal = document.getElementById('modal-review-v2-image');
    if (!modal) {
        return;
    }

    const safeStartIndex = Number.isFinite(startIndex) && startIndex >= 0 && startIndex < images.length
        ? startIndex
        : 0;
    const sortedImages = [
        images[safeStartIndex],
        ...images.filter(function(_, index) {
            return index !== safeStartIndex;
        })
    ];

    const track = modal.querySelector('.review-v2-image-modal-track');
    const slider = modal.querySelector('.review-v2-image-modal-slider');
    const prevButton = modal.querySelector('.review-v2-image-modal-prev');
    const nextButton = modal.querySelector('.review-v2-image-modal-next');

    track.innerHTML = '';
    sortedImages.forEach(function(url) {
        const slide = document.createElement('div');
        slide.className = 'embla-slide review-v2-image-modal-slide';
        const image = document.createElement('img');
        image.className = 'img-fluid';
        image.src = url;
        image.alt = 'Review Image';
        image.loading = 'lazy';
        image.decoding = 'async';
        slide.appendChild(image);
        track.appendChild(slide);
    });

    const showArrows = sortedImages.length > 1;
    prevButton.classList.toggle('d-none', !showArrows);
    nextButton.classList.toggle('d-none', !showArrows);

    if (reviewV2ImageEmbla) {
        reviewV2ImageEmbla.destroy();
        reviewV2ImageEmbla = null;
    }

    reviewV2ImageEmbla = EmblaCarousel(slider, {
        loop: false,
        align: 'center',
        containScroll: 'trimSnaps'
    });

    if (showArrows) {
        prevButton.onclick = function() {
            reviewV2ImageEmbla.scrollPrev();
        };
        nextButton.onclick = function() {
            reviewV2ImageEmbla.scrollNext();
        };
    }

    showModal('modal-review-v2-image');
}

function initReviewImagesCarousel(container) {
    const slider = container.querySelector('.embla-carousel');
    if (!slider || container.classList.contains('embla-initialized')) {
        return;
    }

    const prevButton = container.querySelector('.embla-prev-button');
    const nextButton = container.querySelector('.embla-next-button');

    const embla = EmblaCarousel(slider, {
        loop: false,
        align: 'start',
        slidesToScroll: 1,
        containScroll: 'trimSnaps'
    });

    if (prevButton) {
        prevButton.addEventListener('click', function () {
            embla.scrollPrev();
        });
    }
    if (nextButton) {
        nextButton.addEventListener('click', function () {
            embla.scrollNext();
        });
    }

    container.classList.add('embla-initialized');
    embla.reInit();
}
